import { ActionTree } from 'vuex';
import { RootState }  from '@/store/store.types';
import { State }      from '@/views/settings/store/settings.state.store';
import * as settingsService from '../settings.service';

const actions: ActionTree<State, RootState> = {
  async checkRateChecker({ commit }): Promise<void> {
    try {
      const { data } = await settingsService.checkRateChecker();
      if (data.availability) {
        commit('setRateChecker');
      }
    } catch (e) {
      throw new Error(e);
    }
  },
};

export default actions;
